/**
 * i18n — Multilingual support (7 languages)
 * pt-PT, pt-BR, en, es, fr, de, it
 */

const translations = {
  'pt-PT': {
    _label: 'Português (Portugal)',
    _flag: '🇵🇹',

    // Tabs
    'tab.home': 'Início',
    'tab.stations': 'Estações',
    'tab.search': 'Busca',
    'tab.saved': 'Salvos',
    'tab.settings': 'Configuração',

    // Side panel
    'search.placeholder': 'Buscar estação...',
    'station.count': '{count} estações em {countries} países',
    'home.welcome': '🌍 Ouça louvores de todo o mundo!',
    'home.welcome.sub': 'Toque em <strong>📻 Estações</strong> para explorar rádios gospel de mais de 50 países.',

    // Player
    'player.onair': 'ON AIR',

    // Suggest modal
    'suggest.title': '✦ Sugerir Rádio Gospel',
    'suggest.name': 'Nome da estação *',
    'suggest.url': 'URL do stream *',
    'suggest.website': 'Website (opcional)',
    'suggest.country': 'País',
    'suggest.city': 'Cidade',
    'suggest.notes': 'Notas (opcional)',
    'suggest.notes.placeholder': 'Ex: esta rádio é da minha igreja',
    'suggest.submit': 'Enviar Sugestão',
    'suggest.success': 'Sugestão enviada! Será analisada em breve.',
    'suggest.error': 'Erro ao enviar. Tenta novamente.',

    // Footer
    'footer.credits': 'Créditos',
    'footer.terms': 'Termos',
    'footer.privacy': 'Privacidade',

    // Settings
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.theme.dark': 'Escuro',
    'settings.version': 'Versão',

    // Misc
    'loading': 'A carregar...',
    'error.noStations': 'Nenhuma estação encontrada',
    'error.stream': 'Erro ao conectar à estação',

    // Favorites
    'favorites.filter': 'Favoritas',
    'favorites.toggle': 'Favoritar estação',
    'favorites.empty': 'Nenhuma estação favorita ainda. Toque no ♡ para adicionar!',
  },

  'pt-BR': {
    _label: 'Português (Brasil)',
    _flag: '🇧🇷',

    'tab.home': 'Início',
    'tab.stations': 'Estações',
    'tab.search': 'Busca',
    'tab.saved': 'Salvos',
    'tab.settings': 'Configuração',

    'search.placeholder': 'Buscar estação...',
    'station.count': '{count} estações em {countries} países',
    'home.welcome': '🌍 Ouça louvores de todo o mundo!',
    'home.welcome.sub': 'Toque em <strong>📻 Estações</strong> para explorar rádios gospel de mais de 50 países.',

    'player.onair': 'NO AR',

    'suggest.title': '✦ Sugerir Rádio Gospel',
    'suggest.name': 'Nome da estação *',
    'suggest.url': 'URL do stream *',
    'suggest.website': 'Website (opcional)',
    'suggest.country': 'País',
    'suggest.city': 'Cidade',
    'suggest.notes': 'Notas (opcional)',
    'suggest.notes.placeholder': 'Ex: essa rádio é da minha igreja',
    'suggest.submit': 'Enviar Sugestão',
    'suggest.success': 'Sugestão enviada! Será analisada em breve.',
    'suggest.error': 'Erro ao enviar. Tente novamente.',

    'footer.credits': 'Créditos',
    'footer.terms': 'Termos',
    'footer.privacy': 'Privacidade',

    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.theme.dark': 'Escuro',
    'settings.version': 'Versão',

    'loading': 'Carregando...',
    'error.noStations': 'Nenhuma estação encontrada',
    'error.stream': 'Erro ao conectar à estação',

    'favorites.filter': 'Favoritas',
    'favorites.toggle': 'Favoritar estação',
    'favorites.empty': 'Nenhuma estação favorita ainda. Toque no ♡ para adicionar!',
  },

  'en': {
    _label: 'English',
    _flag: '🇺🇸',

    'tab.home': 'Home',
    'tab.stations': 'Stations',
    'tab.search': 'Search',
    'tab.saved': 'Saved',
    'tab.settings': 'Settings',

    'search.placeholder': 'Search station...',
    'station.count': '{count} stations in {countries} countries',
    'home.welcome': '🌍 Listen to worship from around the world!',
    'home.welcome.sub': 'Tap <strong>📻 Stations</strong> to explore gospel radios from over 50 countries.',

    'player.onair': 'ON AIR',

    'suggest.title': '✦ Suggest Gospel Radio',
    'suggest.name': 'Station name *',
    'suggest.url': 'Stream URL *',
    'suggest.website': 'Website (optional)',
    'suggest.country': 'Country',
    'suggest.city': 'City',
    'suggest.notes': 'Notes (optional)',
    'suggest.notes.placeholder': 'e.g. this radio is from my church',
    'suggest.submit': 'Submit Suggestion',
    'suggest.success': 'Suggestion submitted! It will be reviewed soon.',
    'suggest.error': 'Error submitting. Please try again.',

    'footer.credits': 'Credits',
    'footer.terms': 'Terms',
    'footer.privacy': 'Privacy',

    'settings.language': 'Language',
    'settings.theme': 'Theme',
    'settings.theme.dark': 'Dark',
    'settings.version': 'Version',

    'loading': 'Loading...',
    'error.noStations': 'No stations found',
    'error.stream': 'Error connecting to station',

    'favorites.filter': 'Favorites',
    'favorites.toggle': 'Toggle favorite',
    'favorites.empty': 'No favorite stations yet. Tap the ♡ to add one!',
  },

  'es': {
    _label: 'Español',
    _flag: '🇪🇸',

    'tab.home': 'Inicio',
    'tab.stations': 'Estaciones',
    'tab.search': 'Buscar',
    'tab.saved': 'Guardados',
    'tab.settings': 'Ajustes',

    'search.placeholder': 'Buscar estación...',
    'station.count': '{count} estaciones en {countries} países',
    'home.welcome': '🌍 ¡Escucha alabanzas de todo el mundo!',
    'home.welcome.sub': 'Toca <strong>📻 Estaciones</strong> para explorar radios gospel de más de 50 países.',

    'player.onair': 'EN VIVO',

    'suggest.title': '✦ Sugerir Radio Gospel',
    'suggest.name': 'Nombre de la estación *',
    'suggest.url': 'URL del stream *',
    'suggest.website': 'Sitio web (opcional)',
    'suggest.country': 'País',
    'suggest.city': 'Ciudad',
    'suggest.notes': 'Notas (opcional)',
    'suggest.notes.placeholder': 'Ej: esta radio es de mi iglesia',
    'suggest.submit': 'Enviar Sugerencia',
    'suggest.success': '¡Sugerencia enviada! Será revisada pronto.',
    'suggest.error': 'Error al enviar. Inténtalo de nuevo.',

    'footer.credits': 'Créditos',
    'footer.terms': 'Términos',
    'footer.privacy': 'Privacidad',

    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.theme.dark': 'Oscuro',
    'settings.version': 'Versión',

    'loading': 'Cargando...',
    'error.noStations': 'No se encontraron estaciones',
    'error.stream': 'Error al conectar con la estación',

    'favorites.filter': 'Favoritos',
    'favorites.toggle': 'Marcar favorito',
    'favorites.empty': '¡Aún no tienes estaciones favoritas. Toca el ♡ para añadir una!',
  },

  'fr': {
    _label: 'Français',
    _flag: '🇫🇷',

    'tab.home': 'Accueil',
    'tab.stations': 'Stations',
    'tab.search': 'Recherche',
    'tab.saved': 'Favoris',
    'tab.settings': 'Paramètres',

    'search.placeholder': 'Rechercher une station...',
    'station.count': '{count} stations dans {countries} pays',
    'home.welcome': '🌍 Écoutez des louanges du monde entier !',
    'home.welcome.sub': 'Appuyez sur <strong>📻 Stations</strong> pour explorer les radios gospel de plus de 50 pays.',

    'player.onair': 'EN DIRECT',

    'suggest.title': '✦ Suggérer une Radio Gospel',
    'suggest.name': 'Nom de la station *',
    'suggest.url': 'URL du stream *',
    'suggest.website': 'Site web (optionnel)',
    'suggest.country': 'Pays',
    'suggest.city': 'Ville',
    'suggest.notes': 'Notes (optionnel)',
    'suggest.notes.placeholder': 'Ex : cette radio est celle de mon église',
    'suggest.submit': 'Envoyer la Suggestion',
    'suggest.success': 'Suggestion envoyée ! Elle sera examinée bientôt.',
    'suggest.error': "Erreur lors de l'envoi. Veuillez réessayer.",

    'footer.credits': 'Crédits',
    'footer.terms': 'Conditions',
    'footer.privacy': 'Confidentialité',

    'settings.language': 'Langue',
    'settings.theme': 'Thème',
    'settings.theme.dark': 'Sombre',
    'settings.version': 'Version',

    'loading': 'Chargement...',
    'error.noStations': 'Aucune station trouvée',
    'error.stream': 'Erreur de connexion à la station',

    'favorites.filter': 'Favoris',
    'favorites.toggle': 'Ajouter aux favoris',
    'favorites.empty': "Pas encore de stations favorites. Appuyez sur le ♡ pour en ajouter !",
  },

  'de': {
    _label: 'Deutsch',
    _flag: '🇩🇪',

    'tab.home': 'Start',
    'tab.stations': 'Sender',
    'tab.search': 'Suche',
    'tab.saved': 'Gespeichert',
    'tab.settings': 'Einstellungen',

    'search.placeholder': 'Sender suchen...',
    'station.count': '{count} Sender in {countries} Ländern',
    'home.welcome': '🌍 Höre Lobpreis aus der ganzen Welt!',
    'home.welcome.sub': 'Tippe auf <strong>📻 Sender</strong>, um Gospel-Radios aus über 50 Ländern zu entdecken.',

    'player.onair': 'LIVE',

    'suggest.title': '✦ Gospel-Radio vorschlagen',
    'suggest.name': 'Sendername *',
    'suggest.url': 'Stream-URL *',
    'suggest.website': 'Website (optional)',
    'suggest.country': 'Land',
    'suggest.city': 'Stadt',
    'suggest.notes': 'Anmerkungen (optional)',
    'suggest.notes.placeholder': 'z.B. dieses Radio gehört zu meiner Kirche',
    'suggest.submit': 'Vorschlag senden',
    'suggest.success': 'Vorschlag gesendet! Er wird in Kürze überprüft.',
    'suggest.error': 'Fehler beim Senden. Bitte versuche es erneut.',

    'footer.credits': 'Danksagungen',
    'footer.terms': 'Nutzungsbedingungen',
    'footer.privacy': 'Datenschutz',

    'settings.language': 'Sprache',
    'settings.theme': 'Design',
    'settings.theme.dark': 'Dunkel',
    'settings.version': 'Version',

    'loading': 'Laden...',
    'error.noStations': 'Keine Sender gefunden',
    'error.stream': 'Fehler beim Verbinden mit dem Sender',

    'favorites.filter': 'Favoriten',
    'favorites.toggle': 'Favorit umschalten',
    'favorites.empty': 'Noch keine Lieblingssender. Tippe auf das ♡, um welche hinzuzufügen!',
  },

  'it': {
    _label: 'Italiano',
    _flag: '🇮🇹',

    'tab.home': 'Home',
    'tab.stations': 'Stazioni',
    'tab.search': 'Cerca',
    'tab.saved': 'Salvati',
    'tab.settings': 'Impostazioni',

    'search.placeholder': 'Cerca stazione...',
    'station.count': '{count} stazioni in {countries} paesi',
    'home.welcome': '🌍 Ascolta lodi da tutto il mondo!',
    'home.welcome.sub': 'Tocca <strong>📻 Stazioni</strong> per esplorare radio gospel da oltre 50 paesi.',

    'player.onair': 'IN ONDA',

    'suggest.title': '✦ Suggerisci Radio Gospel',
    'suggest.name': 'Nome della stazione *',
    'suggest.url': 'URL dello stream *',
    'suggest.website': 'Sito web (opzionale)',
    'suggest.country': 'Paese',
    'suggest.city': 'Città',
    'suggest.notes': 'Note (opzionale)',
    'suggest.notes.placeholder': 'Es: questa radio è della mia chiesa',
    'suggest.submit': 'Invia Suggerimento',
    'suggest.success': 'Suggerimento inviato! Sarà esaminato a breve.',
    'suggest.error': "Errore durante l'invio. Riprova.",

    'footer.credits': 'Crediti',
    'footer.terms': 'Termini',
    'footer.privacy': 'Privacy',

    'settings.language': 'Lingua',
    'settings.theme': 'Tema',
    'settings.theme.dark': 'Scuro',
    'settings.version': 'Versione',

    'loading': 'Caricamento...',
    'error.noStations': 'Nessuna stazione trovata',
    'error.stream': 'Errore nella connessione alla stazione',

    'favorites.filter': 'Preferiti',
    'favorites.toggle': 'Aggiungi ai preferiti',
    'favorites.empty': 'Nessuna stazione preferita. Tocca il ♡ per aggiungerne una!',
  },
};

let currentLang = detectLanguage();
const changeCallbacks = [];

function detectLanguage() {
  const saved = localStorage.getItem('wwr_lang');
  if (saved && translations[saved]) return saved;

  const browserLang = navigator.language || 'en';
  if (browserLang.startsWith('pt')) {
    if (browserLang === 'pt-BR') return 'pt-BR';
    return 'pt-PT';
  }
  if (browserLang.startsWith('es')) return 'es';
  if (browserLang.startsWith('fr')) return 'fr';
  if (browserLang.startsWith('de')) return 'de';
  if (browserLang.startsWith('it')) return 'it';
  return 'en';
}

export function t(key, params = {}) {
  const dict = translations[currentLang] || translations['pt-PT'];
  let text = dict[key] || translations['pt-PT'][key] || key;

  for (const [k, v] of Object.entries(params)) {
    text = text.replace(`{${k}}`, v);
  }

  return text;
}

export function setLanguage(lang) {
  if (!translations[lang]) return;
  currentLang = lang;
  localStorage.setItem('wwr_lang', lang);
  changeCallbacks.forEach(cb => cb(lang));
}

export function getLanguage() {
  return currentLang;
}

export function getAvailableLanguages() {
  return Object.keys(translations).map(code => ({
    code,
    label: translations[code]._label,
    flag: translations[code]._flag,
  }));
}

export function onLanguageChange(cb) {
  changeCallbacks.push(cb);
}
